import CalendarPermissionsTable from "./components/form_inputs/CalendarPermissionsTable.vue";
import DayOfWeekSelect from './components/form_inputs/DayOfWeekSelect.vue';
import DateListInput from './components/form_inputs/DateListInput.vue';
import Multiselect from './components/Multiselect.vue';
import MyCoursesColouredTable from './components/form_inputs/MyCoursesColouredTable.vue';
import EditableList from "./components/EditableList.vue";
import Quicksearch from './components/Quicksearch.vue';
import RepetitionInput from "./components/form_inputs/RepetitionInput.vue";
import SidebarWidget from './components/SidebarWidget.vue';
import StudipActionMenu from './components/StudipActionMenu.vue';
import StudipAssetImg from './components/StudipAssetImg.vue';
import StudipDateTime from './components/StudipDateTime.vue';
import StudipDialog from './components/StudipDialog.vue';
import StudipFileSize from './components/StudipFileSize.vue';
import StudipFolderSize from './components/StudipFolderSize.vue';
import StudipIcon from './components/StudipIcon.vue';
import RangeInput from './components/RangeInput.vue';
import Datepicker from './components/Datepicker.vue';
import Datetimepicker from './components/Datetimepicker.vue';
import TextareaWithToolbar from './components/TextareaWithToolbar.vue';
import I18nTextarea from "./components/I18nTextarea.vue";
import StudipWysiwyg from "./components/StudipWysiwyg.vue";
// import StudipLoadingIndicator from './StudipLoadingIndicator.vue';
import StudipMessageBox from './components/StudipMessageBox.vue';
import StudipProxyCheckbox from './components/StudipProxyCheckbox.vue';
import StudipProxiedCheckbox from './components/StudipProxiedCheckbox.vue';
import StudipTooltipIcon from './components/StudipTooltipIcon.vue';
import StudipSelect from './components/StudipSelect.vue';
import StudipMultiPersonSearch from './components/StudipMultiPersonSearch.vue';

const BaseComponents = {
    CalendarPermissionsTable,
    DayOfWeekSelect,
    DateListInput,
    Multiselect,
    MyCoursesColouredTable,
    EditableList,
    Quicksearch,
    RangeInput,
    RepetitionInput,
    SidebarWidget,
    StudipActionMenu,
    StudipAssetImg,
    StudipDateTime,
    Datepicker,
    Datetimepicker,
    StudipDialog,
    StudipFileSize,
    StudipFolderSize,
    StudipIcon,
    I18nTextarea,
    StudipWysiwyg,
//    StudipLoadingIndicator,
    StudipMessageBox,
    StudipProxyCheckbox,
    StudipProxiedCheckbox,
    StudipTooltipIcon,
    StudipSelect,
    TextareaWithToolbar,
    StudipMultiPersonSearch
};

export default BaseComponents;
